/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Serial} from "../Serial";
import {SerialSound} from "../sound/SerialSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class SerialNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay:number = 0.02;
    private _fastStartDelay:number = 0.01;

    constructor() {}

    public async start(flowStateController:FlowStateController) {
        Serial.initialCountUp.remove();
        Serial.bigWinCountUp.remove();
        Serial.waysWon.remove();
        const soundName = Serial.model.data.nextMode.includes("FREESPIN") ? SerialSound.REELS_SPINNING_FS : SerialSound.REELS_SPINNING;
        SerialSound.soundPlayer.playTrack({
            name : soundName,
            repeat : 100
        });
        SerialSound.PLAYING_LOOP_EFFECT = soundName;

        Serial.model.currentSpinPositions = Serial.model.nextSpinPositions;
        Serial.xBetController.featureEnabled = false;
        Serial.background.playSpinEffect();
        await this.resetReels();
        Serial.betTime = Date.now();
        const promises:Promise<any>[] = [];
        Serial.reels.forEach((reel, reelId) => {
            const delay:number = (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId;
            promises.push(
                Serial.enhancerReels[reelId][0].startSpin(Serial.model.nextSpinPositions[reelId][0], delay),
                Serial.enhancerReels[reelId][1].startSpin(Serial.enhancerReels[reelId][1].isOpened && Serial.model.nextSpinPositions[reelId][1], delay),
                reel.startSpin(
                    Serial.model.nextSpinPositions[reelId][2] ||
                    Serial.model.nextSpinPositions[reelId][3] ||
                    Serial.model.nextSpinPositions[reelId][4], delay),
                Serial.enhancerReels[reelId][5].startSpin(Serial.enhancerReels[reelId][5].isOpened && Serial.model.nextSpinPositions[reelId][5], delay),
                Serial.enhancerReels[reelId][6].startSpin(Serial.model.nextSpinPositions[reelId][6], delay),
            );
        });

        Promise.all(promises).then(res => flowStateController.finish());
    }

    private async resetReels():Promise<any> {
        Serial.wildNudgeController.reset();
        let closeSoundPlayed = false;
        await Serial.reels.forEach((reel, reelId) => {
            let playSound:boolean = Serial.enhancerReels[reelId][0].setOpen(Serial.model.enhancerReelsOpened[reelId][0]);
            playSound = Serial.enhancerReels[reelId][1].setOpen(Serial.model.enhancerReelsOpened[reelId][1]) || playSound;
            playSound = Serial.enhancerReels[reelId][5].setOpen(Serial.model.enhancerReelsOpened[reelId][5]) || playSound;
            playSound = Serial.enhancerReels[reelId][6].setOpen(Serial.model.enhancerReelsOpened[reelId][6]) || playSound;
            Serial.reelPositionControls[reelId].arrange();
            if(playSound) {
                if(Serial.model.data.nextMode.includes("RESPIN")) {
                    SerialSound.soundPlayer.playTrack({name : SerialSound.ENHANCER_OPEN[reelId]});
                } else if(!closeSoundPlayed) {
                    closeSoundPlayed = true;
                    SerialSound.soundPlayer.playTrack({name : SerialSound.ENHANCER_CLOSE});
                }
            }
            if(!Serial.model.data.nextMode.includes("RESPIN")) {
                Serial.ways.resetReel(reelId);
            }
        });
        return Promise.resolve();
    }
}